import { ReactNode } from "react";
import { Box, InputBase, Paper, Typography } from "@mui/material";
import { formatShort, digitsToNumber } from "./factoraje.helpers";

interface Props {
  label: string;
  linea: number;
  onChangeLinea: (value: number) => void;
  /** Monto de la línea que todavía no se reparte entre empresas. */
  libre: number;
  /** Aviso y barra de reparto que van debajo del encabezado. */
  children: ReactNode;
  testId: string;
}

/**
 * Replica `.card.fxu-card` + `.fxu-head` del diseño de Flux: la línea editable a la izquierda
 * (input sin caja, 28px) y lo que queda sin asignar a la derecha en `primary.accent`.
 */
export const PaperLineaSolicitada = ({ label, linea, onChangeLinea, libre, children, testId }: Props) => (
  <Paper variant="lendia_paper" sx={{ p: "20px 22px 18px" }}>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 3 }}>
      <Box>
        <Typography sx={{ fontSize: 11, fontWeight: 600, color: "text.secondary", letterSpacing: "0.02em" }}>
          {label}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mt: "6px" }}>
          <Typography component="span" sx={{ fontSize: 24, fontWeight: 600, color: "text.secondary" }}>
            $
          </Typography>
          <InputBase
            autoComplete="off"
            value={linea.toLocaleString("en-US")}
            onChange={(e) => onChangeLinea(digitsToNumber(e.target.value))}
            inputProps={{ "data-testid": testId, inputMode: "numeric" }}
            sx={{
              width: "9ch",
              // 28px del spec (`.fxu-amt-in`): el monto principal de la pantalla.
              fontSize: 28,
              fontWeight: 700,
              letterSpacing: "-0.02em",
              color: "text.primary",
              fontVariantNumeric: "tabular-nums",
              borderBottom: "1px solid transparent",
              "&:hover": { borderColor: "#D5DCE4" },
              "&.Mui-focused": { borderColor: "primary.accent" },
              "& input": { p: 0 },
            }}
          />
          <Typography
            component="span"
            sx={{ fontSize: 12, fontWeight: 600, color: "text.secondary", letterSpacing: "0.04em" }}
          >
            MXN
          </Typography>
        </Box>
      </Box>
      <Box sx={{ textAlign: "right" }}>
        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 700,
            color: "primary.accent",
            letterSpacing: "-0.01em",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {formatShort(libre)}
        </Typography>
        <Typography sx={{ fontSize: 11, fontWeight: 600, color: "text.secondary", letterSpacing: "0.08em" }}>
          SIN ASIGNAR
        </Typography>
      </Box>
    </Box>
    {children}
  </Paper>
);
